import { render, staticRenderFns } from "./BackProduct.vue?vue&type=template&id=0fb161ba&scoped=true"
import script from "./BackProduct.vue?vue&type=script&lang=js"
export * from "./BackProduct.vue?vue&type=script&lang=js"
import style0 from "./BackProduct.vue?vue&type=style&index=0&id=0fb161ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb161ba",
  null
  
)

export default component.exports